import React from 'react';

import Image from 'next/image';

import { IllustrationWrapper } from '@components/Common';
import { EmptyShiftWrapper } from '@components/Shifts/styles';
import { Text } from '@components/TextGroups';

interface EmptyStateProps {
  illustration: string;
  text: string;
  altText?: string;
}

/**
 * Reusable empty state component
 * Used across: SchoolShifts, TeacherShifts
 */
export const EmptyState: React.FC<EmptyStateProps> = ({ illustration, text, altText }) => {
  return (
    <EmptyShiftWrapper>
      <IllustrationWrapper>
        <Image
          priority
          fill
          src={illustration}
          alt={altText || text}
          style={{ objectFit: 'contain' }}
          unoptimized
        />
      </IllustrationWrapper>
      <Text>{text}</Text>
    </EmptyShiftWrapper>
  );
};
